import React from 'react';
import cn from 'classnames';
import { sendEvent } from 'shared/helpers/requests';
import { ReactComponent as StartIcon } from '../../images/start_icon.svg';
import { ReactComponent as WaveIcon } from '../../images/wave_green.svg';
import { ReactComponent as PriceWrapper } from '../../images/price_third_wrapper.svg';
import { ReactComponent as Background } from '../../images/third_block_bg.svg';
import { ReactComponent as WaveBg } from '../../images/third_block_wave.svg';
import { ReactComponent as Wave2Bg } from '../../images/third_block_wave_2.svg';
import { ReactComponent as StarBg } from '../../images/third_block_star.svg';
import { BuyButton } from '../BuyButton';
import { CourseCard } from '../CourseCard';
import { Card } from '../Card';
import { getCards } from '../../utils';
import {
  CardType,
  CourseCardType,
  EVENT_SOURCE,
  EVENT_TYPE,
  Price,
  SubjecCardType,
} from '../../constants';
import { SubjectCard } from '../SubjectCard';
import styles from './ThirdBlock.module.scss';
import { useLocalStorage } from '../../hooks';

type Props = {
  price: Price;
  isSubscription: boolean;
  isCourses: boolean;
  isSubjects: boolean;
  courseParallel: string;
  thirdBlockRef: React.RefObject<HTMLDivElement>;
  onValidationOpen(): void;
};

export function ThirdBlock({
  price,
  isSubscription,
  isCourses,
  isSubjects,
  courseParallel,
  thirdBlockRef,
  onValidationOpen,
}: Props) {
  const cards = getCards(isCourses, isSubscription, isSubjects, courseParallel);
  const [seenSorry] = useLocalStorage('seenSorry', false);

  return (
    <div className={styles.root} ref={thirdBlockRef}>
      {isSubjects && (
        <>
          <StarBg className={cn(styles.starBg, styles.starBg_1)} />
          <StarBg className={cn(styles.starBg, styles.starBg_2)} />
          <WaveBg className={cn(styles.waveBg, styles.waveBg_1)} />
          <Wave2Bg className={cn(styles.waveBg, styles.waveBg_2)} />
        </>
      )}
      <WaveIcon className={cn(styles.waveImg, isCourses && styles.waveImg_isCourses)} />
      <WaveIcon
        className={cn(styles.waveImg, styles.waveImg_right, isCourses && styles.waveImg_isCourses)}
      />
      {!isCourses && !isSubjects && (
        <Background className={cn(styles.background, seenSorry && styles.background_seenSorry)} />
      )}

      {!(isCourses || seenSorry) && (
        <div className={styles.discount}>
          <div>{price.discount}</div>
          <div>{price.basePrice}&nbsp;₽</div>
        </div>
      )}
      <div className={cn(styles.content, isCourses && styles.content_isCourses)}>
        <div className={styles.startWrapper}>
          <StartIcon />
          <h4>Старт в декабре</h4>
        </div>
        <h2 className={cn(styles.title, isCourses && styles.title_isCourses)}>
          {isCourses ? 'Ближайшие курсы' : 'Ближайшие прямые эфиры'}
        </h2>
        {!isCourses && (
          <p className={styles.description}>
            Безлимитный доступ ко&nbsp;всем эфирам по&nbsp;подписке
          </p>
        )}
        {!isSubjects && (
          <div className={cn(styles.cardsWrapper, isCourses && styles.cardsWrapper_courses)}>
            {isCourses
              ? cards.map((card) => (
                  <CourseCard
                    key={card.title}
                    card={card as CourseCardType}
                    onSendEvent={() =>
                      sendEvent({
                        eventSource: EVENT_SOURCE.COURSES,
                        eventType: EVENT_TYPE.CLICK_BUY,
                        eventInfo: JSON.stringify({ course_name: card.title }),
                      })
                    }
                    price={price}
                    onValidationOpen={onValidationOpen}
                  />
                ))
              : cards.map((card) => (
                  <Card
                    key={card.title}
                    {...(card as CardType)}
                    color={card.bgColor}
                    onValidationOpen={onValidationOpen}
                    onSendEvent={() =>
                      sendEvent({
                        eventSource: EVENT_SOURCE[isSubjects ? 'SHKOLA' : 'PODPISKA'],
                        eventType: EVENT_TYPE.CLICK_BUY,
                        eventInfo: JSON.stringify({ place: 'card' }),
                      })
                    }
                  />
                ))}
          </div>
        )}
        {isSubjects && (
          <div className={cn(styles.cardsWrapper, isSubjects && styles.cardsWrapper_subjects)}>
            {cards.map((card) => (
              <SubjectCard
                key={card.title}
                {...(card as SubjecCardType)}
                onSendEvent={() =>
                  sendEvent({
                    eventSource: EVENT_SOURCE.SHKOLA,
                    eventType: EVENT_TYPE.CLICK_BUY,
                    eventInfo: JSON.stringify({ course_name: card.title }),
                  })
                }
                onValidationOpen={onValidationOpen}
              />
            ))}
          </div>
        )}
        {!(isCourses || seenSorry) && (
          <div className={styles.priceWrapper}>
            <div className={styles.priceBlock}>
              <h4 className={styles.priceTitle}>
                {price.priceForLesson}&nbsp;₽&nbsp; за&nbsp;один эфир
              </h4>
              <span className={styles.titleHighlight} />
              <p className={styles.priceDescription}>
                Каждый месяц&nbsp;&mdash; не&nbsp;менее&nbsp; {isSubjects ? 8 : 5}&nbsp;эфиров!
                <br />
                Также доступ к&nbsp;записям и&nbsp;дополнительным материалам
              </p>
              <span className={styles.descriptionHighlight} />
            </div>
            <div className={styles.buttonWrapper}>
              <BuyButton
                onClick={() => {
                  sendEvent({
                    eventSource: EVENT_SOURCE[isSubjects ? 'SHKOLA' : 'PODPISKA'],
                    eventType: EVENT_TYPE.CLICK_BUY,
                    eventInfo: JSON.stringify({ place: 'middle' }),
                  });
                  onValidationOpen();
                }}
              />
              <div className={styles.buttonPriceWrapper}>
                <PriceWrapper />
                <p className={styles.buttonPrice}>
                  {/* TODO isSubjects=true цена должна быть другой */}
                  <span>{price.price}&nbsp;₽&nbsp;</span>на&nbsp;6&nbsp;месяцев
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
